/**
 * W-002 — admin shell (US-A01 AC3).
 *
 * The sidebar is filtered by role. Refine does that for us: every resource is
 * declared with `meta.canDelete` etc. and the ThemedSider asks the
 * access-control provider `can({ resource, action: 'list' })` for each entry,
 * with `hideIfUnauthorized` set in the provider's options. A Moderator
 * therefore never sees Content, Plans, Transactions or System.
 */
import { ThemedLayoutV2 } from '@refinedev/antd'
import type { PropsWithChildren } from 'react'
import { AdminSider } from './AdminSider'
import { Header } from './Header'
import { Title } from './Title'

export const AdminLayout = ({ children }: PropsWithChildren) => (
  <div className="admin-layout">
    <ThemedLayoutV2 Header={Header} Title={Title} Sider={props => <AdminSider {...props} />}>
      <main className="admin-page">{children}</main>
    </ThemedLayoutV2>
  </div>
)
